import usePlateDesignRequest from '@/common/hooks/usePlateDesignRequest';
import useVehicleTypeRequest from '@/common/hooks/useVehicleTypeRequest';
import useAddDamagedConvertData from '@/modules/adjusterReportModules/IncidentParticipants/components/addDamagedPerson/hooks/useAddDamagedConvertData';
import { addDamagedPersonQuery } from '@/modules/adjusterReportModules/IncidentParticipants/queries/postAddDamagedPerson/addDamagedPersonQueryOptions';
import { DamagedPersonFormData } from '@/modules/adjusterReportModules/IncidentParticipants/types/addDamagedPerson.type';
import { useMutation } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useForm } from 'react-hook-form';

const useAddDamagedPersonForms = ({
  postOnSuccess,
}: {
  postOnSuccess: () => void;
}) => {
  const {
    vehicleTypeQuery: { data: vehicleTypeOptions },
  } = useVehicleTypeRequest({
    enabled: true,
  });

  const { convertData } = useAddDamagedConvertData();

  const {
    plateDesignQuery: { data: plateDesignOptions },
  } = usePlateDesignRequest({
    enabled: true,
  });

  const getDefaultValues = useMemo(
    () => ({
      vehicle_type: vehicleTypeOptions?.find((item) => item.enName === 'car'),
      vehicle_plate_design: plateDesignOptions?.find(
        (item) => item.value === 'country',
      ),
    }),
    [vehicleTypeOptions, plateDesignOptions],
  );

  const methods = useForm<DamagedPersonFormData>({
    defaultValues: {
      ...getDefaultValues,
      damaged_type: 'VEHICLE',
      owner_type: 'real',
      gender: 'male',
    },
  });

  const { mutate, isPending } = useMutation({
    ...addDamagedPersonQuery(),
    onSuccess: postOnSuccess,
  });

  const postApi = ({
    formData,
    id,
  }: {
    formData: DamagedPersonFormData;
    id: number;
  }) => {
    const data = convertData({ data: formData });

    mutate({ formData: data, id });
  };
  return { methods, postApi, isPending };
};

export default useAddDamagedPersonForms;
